import { Icon } from "components/Icon";
import { HeaderProps, IButton } from "data/header";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { headerAndBottomVisibleState } from "recoil/atoms";
import styles from "./style.module.css";

const ACCESS_FIRST_PAGE = window.location.href;

export default function Header({
  left,
  right,
  title,
  isVisible,
  url,
}: HeaderProps) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const headerAndBottomVisible = useRecoilValue(headerAndBottomVisibleState);
  const [backCount, setBackCount] = useState(0);

  useEffect(() => {
    if (headerAndBottomVisible.OS === "android") {
      navigate(
        `${location.pathname}?${location.search.replace("?", "")}&test=1`
      );
    }
  }, [headerAndBottomVisible.OS]);

  const leftCont = () => {
    if (left) {
      return (
        <Icon
          name="back"
          onClick={() => {
            if (
              ACCESS_FIRST_PAGE ===
                window.location.href.replace("&test=1", "") ||
              history.length === 1 ||
              pathname === "/"
            ) {
              window.close();
            } else if (pathname.split("/").length <= 2) {
              navigate("/");
            } else {
              if (
                headerAndBottomVisible.OS === "android" &&
                history.length - backCount <= 1
              ) {
                window.close();
              } else {
                setBackCount(backCount + 1);
                history.go(-1);
              }
            }
          }}
        />
      );
    }
    if (url) {
      return <Icon name="back" onClick={() => navigate(url)} />;
    }
    return <></>;
  };

  const rightCont = () => {
    if (typeof right === "object") {
      const button = right as IButton;
      return (
        <div
          style={{ cursor: "pointer", color: button.color }}
          onClick={button.onClick}
        >
          {button.text}
        </div>
      );
    } else {
      return null;
    }
  };
  if (!isVisible) return <></>;

  return (
    <header className={styles.header}>
      <div className={styles.left}>{leftCont()}</div>
      <div className={styles.title}>{title}</div>
      <div className={styles.right}>{rightCont()}</div>
    </header>
  );
}
